var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c(
      "div",
      {},
      [
        _c("h1", { staticStyle: { "font-size": "20px" } }, [
          _vm._v(_vm._s(_vm.$t("i18n_acility_delivery_booking_management")))
        ]),
        _vm._v(" "),
        _c(
          "el-button",
          {
            staticStyle: { "margin-top": "20px" },
            attrs: { type: "primary" },
            on: {
              click: function($event) {
                _vm.excelVisible = true
              }
            }
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("i18n_import_delivery_booking_document"))
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { margin: "20px 0" } },
          [
            _c(
              "el-table",
              { attrs: { data: _vm.pageList, border: "" } },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "boxNos",
                    align: "center",
                    label: _vm.$t("i18n_Box_number")
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "conWareNos",
                    align: "center",
                    label: _vm.$t("i18n_Reservation_warehouse_delivery_number")
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "conWareCode",
                    align: "center",
                    label: _vm.$t("i18n_Reservation_delivery_warehouse"),
                    width: "150"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "beginTime",
                    align: "center",
                    label: _vm.$t(
                      "i18n_Schedule_warehouse_delivery_start_time"
                    ),
                    width: "180"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "endTime",
                    align: "center",
                    label: _vm.$t("i18n_Schedule_warehouse_delivery_end_time"),
                    width: "180"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "remark",
                    align: "center",
                    label: _vm.$t("i18n_Description")
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "block" },
          [
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.currentPage,
                "page-sizes": [10, 20, 50, 100],
                "page-size": _vm.pageSize,
                layout: "total, sizes, prev, pager, next, jumper",
                total: _vm.totalPage
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            attrs: {
              title: _vm.$t("i18n_File_Upload"),
              visible: _vm.excelVisible,
              width: "40%",
              center: ""
            },
            on: {
              "update:visible": function($event) {
                _vm.excelVisible = $event
              }
            }
          },
          [
            _c(
              "el-upload",
              {
                staticClass: "upload-demo",
                staticStyle: { "text-align": "center" },
                attrs: {
                  "show-file-list": false,
                  "on-error": _vm.handleError,
                  "on-success": _vm.handleSuccess,
                  "before-upload": _vm.handleBeforeUpload,
                  drag: "",
                  "http-request": _vm.uploadSectionFile,
                  action: "",
                  multiple: ""
                }
              },
              [
                _c("i", { staticClass: "el-icon-upload" }),
                _vm._v(" "),
                _c("div", { staticClass: "el-upload__text" }, [
                  _vm._v(_vm._s(_vm.$t("i18n_Drag_file_here_or"))),
                  _c("em", [_vm._v(_vm._s(_vm.$t("i18n_click_Upload")))])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "el-upload__tip",
                    attrs: { slot: "tip" },
                    slot: "tip"
                  },
                  [_vm._v(_vm._s(_vm.$t("i18n_xls_and_xlsx_only")))]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer"
              },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-right": "20px" },
                    attrs: { size: "mini" },
                    on: {
                      click: function($event) {
                        _vm.excelVisible = false
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("i18n_cancel")))]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "success" },
                    on: { click: _vm.donwLoadTemplate }
                  },
                  [_vm._v(_vm._s(_vm.$t("i18n_Download_Template")))]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c891d5b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c891d5b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PersonalCenter/FBAheader/FbnAppointment.vue
// module id = null
// module chunks = 